import { Injectable } from '@angular/core';

import { ModalDialogService } from '../../_shared/services/modal-dialog.service';
import { UtilService } from '../../_shared/services/util.service';

import { Location } from './location.model';
import { LocationsModalComponent } from '../components/locations-modal/locations-modal.component';
import { LocationTranslationModalComponent } from '../components/location-translation-modal/location-translation-modal.component';

@Injectable({
  providedIn: 'root',
})
export class LocationModalService {
  constructor(private modalDialogService: ModalDialogService, private utilService: UtilService) {}

  openLocationsModal(successCallback) {
    const options = {
      width: '900px',
      minHeight: '90vh',
      maxHeight: '90vh',
      disableClose: true,
      position: { top: '5vh' },
      data: {
        title: 'LOCATIONS',
      },
      confirmCallback: successCallback,
      // preventCloseOnSave: true,
    };

    this.modalDialogService.open(options, LocationsModalComponent);
  }

  openLocationTranslation(location: Location, language: any) {
    const options = {
      width: '650px',
      panelClass: 'dialog-sidepanel',
      position: { right: '0' },
      data: {
        title: 'LOCATION_DETAILS',
        obj: location,
        params: {
          language: language,
        },
      },
    };

    this.modalDialogService.open(options, LocationTranslationModalComponent);
  }
}
